import React, { FC } from 'react';
import styled from 'styled-components';

interface ICustomErrorMessageProps {
    message: string;
}

const CustomErrorMessage: FC<ICustomErrorMessageProps> = ({ message }) => {
    return <StyledCustomErrorMessage>{message}</StyledCustomErrorMessage>;
};

const StyledCustomErrorMessage = styled.div`
    color: var(--color-error);
    font-size: 16px;
    text-align: center;
`;

export default CustomErrorMessage;
